var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 7,
    viewBox: "0 0 32 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27357 6.54181C1.46737 6.54181 0 5.07444 0 3.26824C0 1.46737 1.46737 0 3.27357 0C5.07977 0 6.54715 1.46737 6.54715 3.26824C6.54715 5.07444 5.07977 6.54181 3.27357 6.54181ZM16.0002 6.54181C14.194 6.54181 12.7267 5.07444 12.7267 3.26824C12.7267 1.46737 14.194 0 16.0002 0C17.8064 0 19.2738 1.46737 19.2738 3.26824C19.2738 5.07444 17.8064 6.54181 16.0002 6.54181ZM25.4525 3.26824C25.4525 5.07444 26.9199 6.54181 28.7261 6.54181C30.5323 6.54181 31.9997 5.07444 31.9997 3.26824C31.9997 1.46737 30.5323 0 28.7261 0C26.9199 0 25.4525 1.46737 25.4525 3.26824Z",
    fill: "#0D2FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.6cd94c3856991ac3fb6bbbfbd1970fbf.svg";
export { ForwardRef as ReactComponent };